import React from 'react';
import { useConnect } from '../../../../hooks/@lore/query-connect';
import { project_networkId } from '../../../utils/query-helpers';

export default function useQuery(props) {
  const {
    network,
    pagination = {},
    params = {}
  } = props;

  return useConnect('evaluationProjectPartner.find', {
    where: {
      eager: {
        $where: {
          ...project_networkId(network),
          ...params
        }
      }
    },
    ...pagination
  }, {
    keepPreviousData: true
  });
}
